/**
 * 
 * key
 * 
 */


const key = 'cG9zdGNybW1hZ2F6aW5l'

export default key 